
<section class="bg-black text-white pt-32 pb-16 px-8 md:px-16">
  <div class="max-w-6xl mx-auto">
    <h1 class="text-4xl md:text-5xl font-black mb-4">Contact <span class="text-varroc-accent">Us</span></h1>
    <p class="text-gray-400 text-lg">Get in touch with us — we'd love to hear from you.</p>
  </div>
</section>

<section class="bg-black py-12 px-8 md:px-16">
  <div class="max-w-6xl mx-auto">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div class="flex flex-col items-center gap-4 bg-white/5 border border-white/10 rounded-2xl p-8 text-center hover:bg-white/8 transition-all">
        <div class="w-16 h-16 bg-varroc-accent/15 rounded-2xl flex items-center justify-center">
          <i class='bx bx-phone-call icon-gradient text-4xl'></i>
        </div>
        <span class="text-white font-bold text-xl">Sales Team</span>
        <span class="text-gray-400 text-sm leading-relaxed">Have questions about subscription plans or deals? Contact a member of our sales team.</span>
        <a class="text-varroc-accent font-medium hover:underline sales_team_email_click" href="mailto:{{SupportEmail}}" (click)="ctaEvent('Sales Team', 'Email Clicked')">{{SupportEmail}}</a>
      </div>
      <div class="flex flex-col items-center gap-4 bg-white/5 border border-white/10 rounded-2xl p-8 text-center hover:bg-white/8 transition-all">
        <div class="w-16 h-16 bg-varroc-accent/15 rounded-2xl flex items-center justify-center">
          <i class='bx bx-support icon-gradient text-4xl'></i>
        </div>
        <span class="text-white font-bold text-xl">Support Team</span>
        <span class="text-gray-400 text-sm leading-relaxed">We can answer any questions about billing, services, and other queries.</span>
        <a class="text-varroc-accent font-medium hover:underline support_team_email_click" href="mailto:{{SupportEmail}}" (click)="ctaEvent('Support Team', 'Email Clicked')">{{SupportEmail}}</a>
      </div>
    </div>
  </div>
</section>

<section class="bg-black px-8 md:px-16">
  <div class="max-w-6xl mx-auto">
    <div class="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-start md:items-center gap-6">
      <div class="w-12 h-12 bg-varroc-accent/15 rounded-xl flex items-center justify-center flex-shrink-0">
        <i class='bx bx-map-pin icon-gradient text-2xl'></i>
      </div>
      <div>
        <h3 class="text-white font-bold text-lg mb-1">Our Office</h3>
        <p class="text-gray-300 font-medium">Varroc Connect Private Limited</p>
        <p class="text-gray-400 text-sm mt-1 leading-relaxed">Elpro International, Chinchwad Station Rd,<br>Chinchwad Gaon, Chinchwad, Pimpri-Chinchwad,<br>Maharashtra 411033</p>
        <a class="mt-3 inline-flex items-center gap-2 text-varroc-accent font-medium hover:underline" [href]="ContactPhoneHref" (click)="ctaEvent('Contact Number', 'Phone Clicked')">
          <i class='bx bx-phone text-base'></i>
          {{ContactPhone}}
        </a>
      </div>
      <a href="https://maps.app.goo.gl/8TUqnsAMVz7Lr6Yv5" target="_blank" rel="noopener noreferrer"
        class="md:ml-auto flex-shrink-0 inline-flex items-center gap-2 border border-varroc-accent/40 text-varroc-accent text-sm font-medium px-5 py-2.5 rounded-lg hover:bg-varroc-accent hover:text-white hover:border-varroc-accent transition-all">
        <i class='bx bx-directions text-base get_directions_button_click'></i>
        Get Directions
      </a>
    </div>
  </div>
</section>